import {URL_PREFIX} from '../config/config';

export function PopupCenter({
  url,
  title,
  w = window.innerWidth * 0.8,
  h = window.innerHeight * 0.8,
  top = window.innerHeight * 0.05,
  left = window.innerWidth * 0.1,
  navigate,
}) {
  // relative url
  if(!/^https?:\/\//i.test(url)) {
    try {
      url = new URL(url, URL_PREFIX).href;
    } catch (e) {
      //invalid url, no prefix
    }
  }
  const newWindow = window.open(
    url,
    title,
    "resizable=yes, scrollbars=no, status=no, width=" +
      w +
      ", height=" +
      h +
      ", top=" +
      top +
      ", left=" +
      left
  );

  //console.log(w, h);
  newWindow.onload = function () {
    //console.log("load new window")
    newWindow.RunCallbackFunction = function (e) {
      if (e.indexOf("navigate") > -1) {
        navigate(e.replace("navigate:", ""));
        newWindow.close();
      }
    };
  };
  // Puts focus on the newWindow
  if (window.focus) {
    newWindow.focus();
  }
}
